module.exports = __webpack_public_path__ + "img/l4.4s.e3c11cab.png";